import api from '../api';
import { TScoreboardResponse } from './scoreboard.types';
export const queryTableauToken = '/bookie/scoreboard/tableau-token';

export const queryTableau = () =>
  api.get<TScoreboardResponse>(queryTableauToken).then((res) => res.data);
